import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { GetCurrentWeather } from '@/shared/domain'
import { WeatherGetCurrentWeatherRepository } from '@/shared/infra/repositories'

export function makeGetCurrentWeather(): GetCurrentWeather {
  return new WeatherGetCurrentWeatherRepository(makeSupabaseEdgeHttpClient()).execute
}
